import { CHANGE_NAVBAR_TITLE } from "./action.types"

export const changeNavbarTitle = (title) => {
    return {
        type: CHANGE_NAVBAR_TITLE,
        payload: title
    }
}